import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import './SchoolMeetingsEntry';
import './ReviewToolbar';
import './schoolSuspendEntry';

const FaqSchool = lazy(() => import('./FAQSchool'));
const SchoolReviewForm = lazy(() => import('./schoolReviewFormEntryComponent'));
const SchoolLegalInformation = lazy(() => import('./schoolLegalInformationEntry'));

document.addEventListener('DOMContentLoaded', () => {
  const schoolPage = document.getElementById('root-node');
  const root = createRoot(schoolPage);
  const faqNode = document.getElementById('react-faq-accordion');
  const reviewFormNode = document.getElementById('react-school-review-form');
  const schoolLegalInformationNode = document.getElementById('legal-information');

  root.render(
    <Suspense fallback={<div>Chargement...</div>}>
      <FaqSchool node={faqNode} />
      <SchoolReviewForm node={reviewFormNode} />
      <SchoolLegalInformation node={schoolLegalInformationNode} />
    </Suspense>,
  );
});
